import {
    IS_SIDE_BAR_TOPOLOGY_OPEN,
    SIDE_BAR_TOPOLOGY_FLOATING,
    SELECTED_NODE_TOPOLOGY,
    UPDATE_DELETE_MODAL,
    UPDATE_IMPORT_MODAL,
    SHOW_EXPORT_ALERT,
    SHOW_GROUP_CLONE_MODAL,
    SHOW_GROUP_DOWNLOAD_SUCCESS_ALERT,
    SHOW_GROUP_CONFIGURE_MODAL,
    SELECTED_SWITCH_TAB,
    SELECTED_GROUP_NAME,
    GROUP_DOWNLOAD,
    UPDATE_SIDEBAR_WIDTH
} from '../constants/topologyConstants';

/**
 * Reducer function for managing topology state.
 *
 * @param {object} state - Current state of the topology.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const topologyReducer = (
    state = {
        sideBarTopologyOpen : null,
        sideBarTopologyFloating: false,
        selectedNode : {},
        switchTab : { label: 'Access Point', id: 'access-point' },
        selectedGroupName: '',
        sidebarWidth: 260
    }, 
    action
) => {
	switch (action.type) {
		case IS_SIDE_BAR_TOPOLOGY_OPEN:
			return { 
                ...state,
                sideBarTopologyOpen: action.payload
            };
        case SIDE_BAR_TOPOLOGY_FLOATING:
			return { 
                ...state,
                sideBarTopologyFloating: action.payload
            };
        case SELECTED_NODE_TOPOLOGY: {
            return { 
                ...state,
                selectedNode: action.payload
            };
        }
        case SELECTED_GROUP_NAME: {
            return { 
                ...state,
                groupName: action.payload
            };
        }
        case SELECTED_SWITCH_TAB: {
            return { 
                ...state,
                switchTab: action.payload
            };
        }
        case UPDATE_SIDEBAR_WIDTH: {
            return { 
                ...state,
                sidebarWidth: action.payload
            };
        }
		default:
			return state;
	}
};

export const topologyModalsReducer = (
    state = {
        showDeleteModal: false,
        showImportModal: false,
        showExportAlert: false,
        showGroupCloneModal: false,
        showGroupDownloadSuccessAlert: false,
        showGroupConfigureModal: false,
        showDownload:false
    }, 
    action
) => {
	switch (action.type) {
        case UPDATE_DELETE_MODAL: {
            return {
                ...state,
                showDeleteModal: action.payload
            }
        }
        case UPDATE_IMPORT_MODAL: {
            return {
                ...state,
                showImportModal: action.payload
            }
        }
        case SHOW_EXPORT_ALERT: {
            return {
                ...state,
                showExportAlert: action.payload
            }
        }
        case SHOW_GROUP_CLONE_MODAL: {
            return {
                ...state,
                showGroupCloneModal: action.payload
            }
        }
        case SHOW_GROUP_CONFIGURE_MODAL: {
            return {
                ...state,
                showGroupConfigureModal: action.payload,
                // Values the assistant asked the form to open with. Cleared
                // with the modal, so opening it by hand later never inherits
                // what a previous request asked for.
                groupConfigureInitialValues: action.payload
                    ? action.agentInitialValues || null
                    : null
            }
        }
        case SHOW_GROUP_DOWNLOAD_SUCCESS_ALERT: {
            return {
                ...state,
                showGroupDownloadSuccessAlert: action.payload
            }
        }
        case GROUP_DOWNLOAD: {
            return {
                ...state,
                showDownload: action.payload
            }
        }
		default:
			return state;
	}
};
